import { isDpdLocalDomain } from "../app/app.modes";
import {
  DPD_BUSINESS_ID,
  DPD_LOCAL_BUSINESS_ID,
} from "../userDetailsForm/accountDetails/accountDetails.constants";
import {
  SEARCH_FORM_ERRORS,
  SPECIAL_SERVICE_EXCLUSIONS_FIELD,
} from "./customerSettings.constants";

export const getInitialCustomerSettingsSearchFormValues = () => ({
  businessId: isDpdLocalDomain() ? DPD_LOCAL_BUSINESS_ID : DPD_BUSINESS_ID,
  account: "",
});

export const getInitialCustomerSettingsFormValues = () => ({
  [SPECIAL_SERVICE_EXCLUSIONS_FIELD]: [],
});

export const validateSearchFormValues = ({ account = "" }) => {
  const errors = {};

  if (account !== "0" && [6, 7].indexOf(account.length) === -1) {
    errors.account = SEARCH_FORM_ERRORS.MISSING_ACCOUNT;
  }

  return errors;
};

export const customerCustomerSettingsFromForms = (
  searchForm,
  customerSettingsForm
) => ({
  ...searchForm,
  ...customerSettingsForm,
  businessId: searchForm.businessId.toString(),
});
